import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FolderOpen, MoreHorizontal, Bot, ListChecks } from 'lucide-react';

interface MobileBottomTabBarProps {
  onMorePress: () => void;
}

const tabs = [
  { key: 'home', label: 'Home', icon: LayoutDashboard, route: '/', exact: true },
  { key: 'matters', label: 'Matters', icon: FolderOpen, route: '/matters' },
  { key: 'work', label: 'Work', icon: Bot, route: '/ai-hub' },
  { key: 'tasks', label: 'Tasks', icon: ListChecks, route: '/tasks' },
] as const;

export default function MobileBottomTabBar({ onMorePress }: MobileBottomTabBarProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (route: string, exact?: boolean) => {
    if (exact) return location.pathname === route;
    return location.pathname.startsWith(route);
  };

  return (
    <nav
      aria-label="Primary mobile navigation"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'calc(var(--mobile-tab-bar-height, 56px) + var(--safe-bottom, env(safe-area-inset-bottom, 0px)))',
        paddingBottom: 'var(--safe-bottom, env(safe-area-inset-bottom, 0px))',
        background: 'var(--card)',
        borderTop: '1px solid var(--border)',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-around',
        zIndex: 900,
      }}
    >
      {tabs.map((tab) => {
        const active = isActive(tab.route, 'exact' in tab ? tab.exact : undefined);
        const Icon = tab.icon;
        return (
          <button
            key={tab.key}
            onClick={() => navigate(tab.route)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.15rem',
              paddingTop: '0.5rem',
              paddingBottom: '0.25rem',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: active ? 'var(--primary)' : 'var(--text-muted)',
              minHeight: 56,
              transition: 'color 0.15s ease',
            }}
          >
            <Icon size={24} />
            <span style={{ fontSize: '0.78rem', fontWeight: 600, lineHeight: 1 }}>{tab.label}</span>
          </button>
        );
      })}

      {/* More tab */}
      <button
        onClick={onMorePress}
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.15rem',
          paddingTop: '0.5rem',
          paddingBottom: '0.25rem',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--text-muted)',
          minHeight: 56,
          transition: 'color 0.15s ease',
        }}
      >
        <MoreHorizontal size={24} />
        <span style={{ fontSize: '0.78rem', fontWeight: 600, lineHeight: 1 }}>More</span>
      </button>
    </nav>
  );
}
